/**
 * 数组相关工具
 * @author SPY
 * @description -- 对于数组排序、数组转换等的操作函数
 * @date -- 2019/10/23
 */
import React, { useState, useEffect, useRef } from 'react';
import { message, Modal, Upload, Form } from 'antd';
import { UploadOutlined, PlusOutlined } from '@ant-design/icons';
import { getQiNiuToken } from '../../../utils/api';
import {FILEACTIONURL} from '../../../config/index'

const UploadForm = (props) => {
  console.log(props);
  const [form] = Form.useForm();
  const [token, setToken] = useState();
  const [previewImage, setPreviewImage] = useState();
  const [previewVisible, setPreviewVisible] = useState();
  const [previewTitle, setPreviewTitle] = useState();
  const [indexStatus, setIndexStatus] = useState();
  const [fileList, setFileList] = useState([]);
  const [beforeFileList, setBeforeFileList] = useState([])
  const [suffix, setSuffix] = useState('')
  useEffect(() => {
    if (props.fileList && props.fileList != undefined) {
      console.log(props.fileList);

      if (props.fileList.length != 0) {
        setIndexStatus(false)
        setFileList(
          [{
            uid: '-1',
            name: 'image.png',
            status: 'done',
            url: props.fileList[0],
          },]
        )
      }
    }
  }, [props.fileList])
  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const handlePreview = async (file) => {

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };

  const handleCancel = () => {
    setPreviewVisible(false);
  };
  const uploadButton = (
    <div>
      <PlusOutlined />
      {/* <div style={{ marginTop: 8 }}>Upload</div> */}
    </div>
  );
  useEffect(async () => {
    const result = await getQiNiuToken();
    if (result) {
      setToken(result);
    }
    if (props.imgArrDetail) {
      console.log('props.imgArrDetail', props.imgArrDetail);
      const initImgArr = [];
      let imgArr = props.imgArrDetail;
      if (typeof imgArr == 'string') {
        imgArr = imgArr.split(',');
      }
      for (let i = 0; i < imgArr.length; i++) {
        // initImgArr.push(imgArr[i])
        initImgArr.push({
          uid: i,
          status: 'done',
          url: imgArr[i],
        });
      }
      setFileList(initImgArr);
    }
  }, []);
  const propsInfo = {
    name: 'file',
    listType: 'picture-card',
    // action: 'https://up-z0.qiniup.com',
    action: FILEACTIONURL,
    headers: {
      authorization: 'authorization-text',
    },
    data: {
      // token: token,
      output:'json',
      scene:'pubuilcHouse',
      // key: Date.now() + Math.floor(Math.random() * (999999 - 100000) + 100000) + 1 + suffix,
    },
    onChange(info) {
      console.log('info.file:', info);
      setIndexStatus(info.fileList.length >= 1 ? false : true)
      if (info.file.status !== 'uploading') {
        let fileListArr = info.fileList;
        let imgArr = [];
        console.log('info.file:', fileListArr);
        fileListArr.forEach((element) => {
          console.log(element);
          element.response
            ? imgArr.push(element.response.src)
            // ? imgArr.push('https://qiniu.toseesoft.net/' + element.response.key)
            : imgArr.push(element.url);
        });
        // if (props?.type === '01') {
        props.fileUrl(imgArr, props.type, props.index, props.imgIndex);
        // } else {
        //   props.transactionUrl(imgArr);
        // }

        console.log('fileList', fileList);
        console.log('imgIndex', props.imgIndex);
        console.log(info.file, info.fileList);
        // setIndexStatus(fileList.length>(props.imgIndex?props.imgIndex:2));
      }
      setFileList(info.fileList);
      if (info.file.status === 'done') {
        message.success(`${info.file.name} 上传成功`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} 上传失败`);
      }
    },
  };

  return (
    <div>
      <Upload
        name="fileUrl"
        {...propsInfo}
        defaultFileList={beforeFileList}
        onPreview={handlePreview}
        // onChange={(e) => {
        //   console.log('-------------------',e);
        //   handleChange(e);
        // }}
        fileList={fileList}
        
        beforeUpload={
          (file, fileList) => {
            let name = file.name
            let suffix = name.substring(name.lastIndexOf("."), name.length)
            setSuffix(suffix)
          }
        }
      >
        {/* {indexStatus==false ? null : 111} */}
        {indexStatus == false ? null : uploadButton}
      </Upload>
      <Modal visible={previewVisible} title={previewTitle} footer={null} onCancel={handleCancel}>
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </div>
  );
};

export default UploadForm;
